<template>
    <card :loading="loading" xs-tile :flat="flat">
        <lazy-card-title v-if="title" class="none sm:flex">{{ title }}</lazy-card-title>
        <lazy-card-subtitle v-if="subtitle" small class="pt-24 sm:pt-4">{{ subtitle }}</lazy-card-subtitle>
        <card-text :class="noPadding ? 'p-0' : 'pt-8 pb-24'" fill>
            <slot/>
        </card-text>
    </card>
</template>

<script>

export default {
        name: "ProfileEditFormLayout",

        props: {
            title: {
                type: String,
                default: null
            },

            subtitle: {
                type: String,
                default: null
            },

            noPadding: {
                type: Boolean,
                default: false
            },

            loading: {
                type: Boolean,
                default: false
            },

            flat: {
                type: Boolean,
                default: false
            }
        }
    }
</script>